// @ts-ignore
import React from 'react';
// @ts-ignore
import {InputFactory} from "../input";
import "./form.scss";
import Button from "react-bootstrap/Button";

interface FormInterface {
    id: string;
    label: string;
    inputs: Array<InputFactory>;
    save_button?: {
        label: string;
        onClick: any;
        show: boolean;
    }
}

interface FormState {
    value?: string;
}

export class FormGenerator extends React.Component<FormInterface, any>
{
    render() {
        const { id, label, inputs, save_button } = this.props;

        return <form  onSubmit={() => {save_button?.onClick()}}><div className={"form_container"}>
            
            { inputs.map((input) => {
                //input.setValue('asd')

                return input
            }) }
            { save_button && save_button.show ? 
            <input type="submit" value="Prześlij zgłoszenie" className="submitBtn btn btn-success"/> : null } 
        </div>
        </form>
    }
}
